<template>
  <div class="user-messsage">
    <h2 class="user-title Medium">修改密码</h2>
    <div class="form">
      <el-form
        v-loading="loading"
        element-loading-text="修改中..."
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        label-position="top"
        class="demo-ruleForm"
      >
        <el-form-item label="原密码" prop="password">
          <el-input
            v-model="ruleForm.password"
            show-password
            placeholder="请输入原密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="ruleForm.newPassword"
            show-password
            placeholder="6-20字符，字母符号组合"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="again">
          <el-input
            v-model="ruleForm.again"
            show-password
            placeholder="6-20字符，字母符号组合"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span @click="goRetrieve" class="forget">忘记密码</span>
          <div @click="resetPwd" class="edit">保存编辑</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { resetPwd } from "@/request/member.js";
export default {
  name: "changePasword",
  data() {
    var validateConfirmWord = (rule, value, callback) => {
      if (value !== this.ruleForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      ruleForm: {
        password: "",
        newPassword: "",
        again: "",
      },
      rules: {
        password: [
          { required: true, message: "请输入原密码", trigger: "change" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "change" },
        ],
        again: [
          { required: true, message: "请再次输入新密码", trigger: "change" },
          { validator: validateConfirmWord, trigger: "change" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("member", ["Token", "ProfileId"]),
  },
  methods: {
    ...mapMutations("member", ["updateUserInfo", "updataToken"]),
    goRetrieve() {
      this.$router.push({
        path: "/retrieve",
      });
    },
    resetPwd() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          resetPwd(this.Token, {
            oldpassWord: this.ruleForm.password,
            newpassWord: this.ruleForm.newPassword,
            cOnfirmNewpassWord: this.ruleForm.again,
            profileId: this.ProfileId,
          })
            .then((res) => {
              if(res.response.Code == 200){
                this.$message({
                message: res.msg,
                type: "success",
              });
              this.updataToken(res.response.Token);
              this.loading = false;
              this.$router.push({
                path: "/win",
                query: { type: 4 },
              });
              }else{
                this.$message.error(res.response.Data)
              }
              
            })
            .catch((err) => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.form {
  width: 280px;
}
.edit {
  width: 180px;
  height: 40px;
  display: flex;
  background: #2a82e4;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  font-weight: 400;
  margin-top: 20px;
  cursor: pointer;
}
.forget {
  font-size: 14px;
  color: #2a82e4;
  cursor: pointer;
}
</style>